import tw from 'tailwind-styled-components'
import {IconButtonNew} from '@components/common/base/buttons'
import {IconTabler} from '@components/common/icon-tabler/icon-tabler'

export const TwInputContainer = tw.div`
  flex
  flex-col
  gap-4
`

export const TwLabel = tw.div<{$disabled?: boolean}>`
  select-none
  text-sm-regular
  ${p => (p.$disabled ? 'text-disabled' : 'text-secondary')}
  flex
`

export const TwRightLabel = tw.div`
  ml-auto
`

export const TwSupport = tw.div<{$disabled?: boolean}>`
  select-none
  text-xs-regular
  ${p => (p.$disabled ? 'text-disabled' : 'text-secondary')}
`

export const TwInputWrapper = tw.div`
  relative
`

// A `type` instead of an `interface` because of the following error:
//   Type 'IconProps' does not satisfy the constraint 'TransientProps'
//   Index signature for type '`$${string}`' is missing in type 'IconProps'.
type IconProps = {
  $size: 'sm' | 'md' | 'lg'
  $left?: boolean
  $right?: boolean
  $disabled?: boolean
  $error?: boolean
}

const iconMixin = (p: IconProps) => {
  const cx: string[] = []

  if (p.$disabled) {
    cx.push('text-icon-disabled')
  } else if (p.$error) {
    cx.push('text-error')
  } else {
    cx.push('text-icon-secondary')
  }

  if (p.$size === 'md') {
    cx.push('top-8')
  } else if (p.$size === 'lg') {
    cx.push('top-12')
  }
  if (p.$left) {
    cx.push('left-12')
  } else if (p.$right) {
    cx.push('right-12')
  }
  return cx.join(' ')
}

export const TwIcon = tw(IconTabler)<IconProps>`
  absolute
  pointer-events-none
  ${p => iconMixin(p)}
`

export const TwIconButton = tw(IconButtonNew)<IconProps>`
  absolute
  ${p => iconMixin(p)}
`

export const TwInput = tw.input<{
  $size: 'md' | 'lg'
  $disabled?: boolean
  $error?: boolean
  $iconLeft?: any
  $iconRight?: any
  $cursorView?: boolean
  $baseFocusStyle?: boolean
  $type?: React.HTMLInputTypeAttribute
  $isAutoWidth?: boolean
}>`
  h-32
  m-0
  border-none
  outline-none

  bg-background-primary
  disabled:bg-background-disabled
  disabled:shadow-none

  rounded-8
  shadow-border-1

  focus:outline
  focus:outline-solid
  focus:outline-offset-0
  focus:outline-1
  focus:border-none
  focus:bg-background-primary

  text-sm-regular

  ${p => {
    const cx: string[] = [
      p.$iconLeft ? 'pl-36' : 'pl-12',
      p.$iconRight ? 'pr-36' : 'pr-12'
    ]

    if (p.$size === 'md') {
      cx.push('py-8')
    } else if (p.$size === 'lg') {
      cx.push('py-12')
    }

    if (p.$disabled) {
      cx.push('text-disabled', 'placeholder:text-disabled')
    } else {
      cx.push('text-primary', 'placeholder:text-placeholder')
    }

    if (p.$error) {
      cx.push(
        'shadow-status-error',
        'focus:outline-status-error',
        'focus:shadow-status-error'
      )
    } else if (p.$baseFocusStyle) {
      cx.push(
        'shadow-line-base',
        'focus:!outline-shadow-line-base',
        'focus:!shadow-line-base'
      )
    } else {
      cx.push(
        'shadow-line-base',
        'focus:!outline-action-default',
        'focus:!shadow-action-default'
      )
    }

    if (p.$cursorView) {
      cx.push('shadow-border-0 focus:!outline-0 shadow-none bg-transparent')
    }

    cx.push(!p.$isAutoWidth ? 'w-full' : 'w-0')

    if (p.$type === 'number') {
      cx.push('text-center', 'no-spinner')
    }

    return cx.join(' ')
  }}
`
